export const nl = {
  // 通用
  common: {
    control: 'Besturing',
    close: '✕',
    fullscreen: 'Volledig scherm',
    exitFullscreen: 'Volledig scherm verlaten',
    screenSize: 'Schermgrootte',
    inches: 'inch',
    currentMeasurement: 'Huidige meting',
    diagonal: 'Diagonaal',
    window: 'Venster',
    fullscreenMode: 'Volledig scherm',
  },

  // 设备类型
  deviceType: {
    phone: 'Telefoon',
    tablet: 'Tablet',
    display: 'Display',
  },

  // 控制面板
  controls: {
    title: 'Besturing',
    brand: 'Merk',
    model: 'Model',
    selectBrand: 'Selecteer merk',
    selectModel: 'Selecteer model',
    screenSizeInches: 'Schermgrootte (inch)',
    mobileTip: '💡 Mobiele apparaten passen zich automatisch aan aan schermgrootte',
    unit: 'Eenheid',
    centimeters: 'Centimeters',
    inches: 'Inches',
  },

  // 品牌
  brands: {
    iPhone: 'iPhone',
    Samsung: 'Samsung',
    Xiaomi: 'Xiaomi',
    Huawei: 'Huawei',
    OPPO: 'OPPO',
    vivo: 'vivo',
    OnePlus: 'OnePlus',
    iPad: 'iPad',
    other: 'Andere',
    custom: 'Aangepaste grootte',
  },

  // 语言检测
  languageDetection: {
    title: 'Taaldetectie',
    detected: 'We hebben gedetecteerd dat u mogelijk in',
    switchTo: 'Overschakelen naar',
    stay: 'Blijf in het Engels',
    switch: 'Overschakelen',
  },

  // 尺寸信息
  measurement: {
    current: 'Huidige meting',
    width: 'Breedte',
    height: 'Hoogte',
    diagonal: 'Diagonaal',
    pixels: 'pixels',
  },
}; 